import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { BaseService } from "./base.service";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";
import { IEvent } from "../interfaces/ievent";

@Injectable()
export class EventService extends BaseService {
    constructor(httpClient: HttpClient, toastr: ToastrService, store: Store<IAppStore>) {
        super(httpClient, toastr, store);
    }

    getEvents(): Observable<IEvent[]> {
        return super.get("/api/event").pipe(
            map((res: any) => res)
        );
    }

    getEvent(id: number): Observable<IEvent> {
        return super.get(`/api/event/${id}`).pipe(
            map((res: any) => res as IEvent)
        );
    }

    createEvent(event: IEvent): Observable<IEvent> {
        return super.post("/api/event", event).pipe(
            map((res: any) => res as IEvent)
        );
    }

    updateEvent(event: IEvent): Observable<IEvent> {
        return super.put(`/api/event/${event.id}`, event).pipe(
            map((res: any) => res as IEvent)
        );
    }

    // Alias methods for compatibility
    create(event: IEvent): Observable<IEvent> {
        return this.createEvent(event);
    }

    update(event: IEvent): Observable<IEvent> {
        return this.updateEvent(event);
    }
}
